import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api/api.service';
import { InitiativesMembers } from '../manage-initiative-member/interfaces/manage-initiative-member.interface';
import { InitiativeGettingReady } from './interfaces/initiative-getting-ready.interfaces';
import { IntermediaryInitiativeList } from './interfaces/intermediary-initiative-list.interfaces';

@Injectable({
  providedIn: ApiService,
})
export class DashboardService {
  constructor(private api: ApiService) {}

  public getInitiatives(network_id: string): Observable<InitiativesMembers> {
    const url = `intermediary/${network_id}/initiatives/`;
    return this.api.get<InitiativesMembers>(url);
  }

  public getInitiativesList(
    network_id: string
  ): Observable<IntermediaryInitiativeList> {
    const url = `intermediary/${network_id}/initiative-lists/`;
    return this.api.get(url);
  }

  public getGettingReady(
    init_id: string
  ): Observable<InitiativeGettingReady[]> {
    const url = `initiative/${init_id}/getting-ready/`;
    return this.api.get(url);
  }

  public getCollectingSurveys(init_id): Observable<any> {
    const url = `initiative/${init_id}/collecting-surveys/`;
    return this.api.get(url);
  }
}
